import React from 'react'
import Header from '../Components/Header/header'
import Reviews from '../Components/Reviews/reviews'
import Footer from '../Components/Footer/footer'
import ReviewSubmit from '../Components/ReviewSubmit/reviewsubmit'

const Testimonials = () => {
  return (
    <div>
    <Header/>
        <div className="breadcrumb-container">
        <div className="breadcrumb">
          <h2>Explore What My Clients Says!</h2>
        </div>
      </div>
      <Reviews/>
      <ReviewSubmit/>
      <Footer/>
    </div>
  )
}

export default Testimonials